import React, { useEffect, useState } from "react";
import { Navbar } from "../../Components/Navbar";
import { useHistory } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrimaryButton from "../../Components/Common/PrimaryButton";
import { createNewTableRowLinkRegister, dropValueMappingLinkRegister, getLinkRegister, mappingLinkRegister, onchangeMappingLinkRegister } from "../../services/api/apiHandler";
import swal from 'sweetalert';
import "./linkRegister.css";
import Loading from "../../Components/Common/Loader/Loading";
import LinkRegisterTable from "./LinkRegisterTable";
import LinkRegisterAccordion from "./LinkRegisterAccordion";
import LoaderTwo from "../../Components/Common/Loader/LoaderTwo";
import moment from "moment";
import Card from '@mui/material/Card';

//////////////////////////////////////////////
import Sidebar from "../../myfin_v2/elements/Sidebar";
import commoncss from "../../myfin_v2/css/common.module.css"
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css"
import workSpaceCss from "../../myfin_v2/css/workSpaceOverView.module.css"

import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";
import {ReactComponent as SearchIcon} from "../../myfin_v2/assets/icons/SearchIcon.svg";


import FSCss from "../../myfin_v2/css/overview.module.css";



import { ReactComponent as LeftArrowIcon } from "../../myfin_v2/assets/icons/left_arrow.svg"
import { ReactComponent as GreenDot } from "../../myfin_v2/assets/icons/greenDotSmall.svg"
import { getAllLinkedRegistersApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import { Button } from "../../myfin_v2/elements/Button";
import buttoncss from "../../myfin_v2/css/button.module.css";




const FSTopBar = ({
  // setLoanUploadModal,
  ShowInDecimals,
  setShowInDecimals,
  //  history,
  softDeletedData,
  deleteItemsModel,
  setDeleteItemsModal,
  handleDelete,
  setHandleDelete
}) => {
  const history = useHistory();
  // const dispatch = useDispatch();
  return (

    <div className={FSCss.w100}>

      <div className={FSCss.uploadLoansMainContainer}>

      </div>

      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
          {/* <div className={FSCss.heading}>Loan Listing</div> */}
          {/* <div className={FSCss.heading}  > */}

          <div className={FSCss.iconContainer}>
            {/* <SearchIcon/> */}
            <LeftArrowIcon className="clickable"
              //   onClick={redirectToBookClosureHome}
              //  onClick={() => {dispatch({ type: "NOTE_KEY", payload: 2 }); history.push(`/financialstatement`) }}
              onClick={() => { history.push(`/myfinV2/standalonefs`) }}
            />
          </div>
          <div className={FSCss.topBarHeading} style={{ "align-content": "center" }}>Workspace</div>
          <div className={FSCss.iconDotContainer}>
            {/* <SearchIcon/> */}
            <GreenDot />
          </div>


          <div className={FSCss.topBarHeading} style={{ "align-content": "center" }}>Standalone Financial Statements</div>
          <div className={FSCss.iconDotContainer}>
            {/* <SearchIcon/> */}
            <GreenDot />
          </div>
          <div className={FSCss.topBarSubHeading}>Financial Statement name</div>

          {/* </div> */}
        </div>

      </div>
    </div>
  )
};

const normalizeTwoYear = (data = {}) => {
  const cy = data.currentYear || [];
  const py = data.previousYear || [];
  const rows = Math.max(cy.length, py.length, 1);

  return Array.from({ length: rows }).map((_, i) => ({
    cy: cy[i] ? [cy[i]] : [],
    py: py[i] ? [py[i]] : [],
    mappedRegisterIds: {
      cy: cy[i]?._id || "",
      py: py[i]?._id || "",
    },
  }));
};

const normalizeLoan = (data = {}) => {
  const cy = data.currentYear || [];
  const py = data.previousYear || [];
  const pcy = data.precedingYear || [];
  const rows = Math.max(cy.length, py.length, pcy.length, 1);

  return Array.from({ length: rows }).map((_, i) => ({
    cy: cy[i] ? [cy[i]] : [],
    py: py[i] ? [py[i]] : [],
    preceding_year: pcy[i] ? [pcy[i]] : [],
    mappedRegisterIds: {
      cy: cy[i]?._id || "",
      py: py[i]?._id || "",
      preceding_year: pcy[i]?._id || "",
    },
  }));
};

const LinkRegister = () => {
  const history = useHistory();
  const project_id = localStorage.getItem('project_id');
  const tb_id = localStorage.getItem('tb_id');
  const user = JSON.parse(localStorage.getItem('user'));
  const [linkRegisterData, setLinkRegisterData] = useState({});
  const [linkRegisterTableData, setLinkRegisterTableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [dropLoading, setDropLoading] = useState(false);
  const [draggedData, setDraggedData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selInvestmentRegCY, setSelInvestmentRegCY] = useState([]);
  const [selInvestmentRegPY, setSelInvestmentRegPY] = useState([]);
  const [selRecRegCY, setSelRecRegCY] = useState([]);
  const [selRecRegPY, setSelRecRegPY] = useState([]);
  const [selPayRegCY, setSelPayRegCY] = useState([]);
  const [selPayRegPY, setSelPayRegPY] = useState([]);
  const [selLoanRegCY, setSelLoanRegCY] = useState([]);
  const [selLoanRegPY, setSelLoanRegPY] = useState([]);
  const [selLoanPrecedingYear, setSelLoanPrecedingYear] = useState([]);
  const [selLeaseRegCY, setSelLeaseRegCY] = useState([]);
  const [selLeaseRegPY, setSelLeaseRegPY] = useState([]);
  const [selFixedAssetsRegCY, setSelFixedAssetsRegCY] = useState([]);
  const [selFixedAssetsRegPY, setSelFixedAssetsRegPY] = useState([]);
  const [selSalesRegCY, setSelSalesRegCY] = useState([]);
  const [selSalesRegPY, setSelSalesRegPY] = useState([]);
  const [selPurchaseRegCY, setSelPurchaseRegCY] = useState([]);
  const [selPurchaseRegPY, setSelPurchaseRegPY] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [previousYear, setPreviousYear] = useState(null);

  useEffect(() => {
    setLoading(true);
    getLinkRegister(project_id, tb_id).then(response => {
      setLoading(false);
      setLinkRegisterData(response.data.linkRegisterData);

    }).catch(error => {
      setLoading(false);
      swal("Error", error.response.data.error || "Error: Link Register API Failed!", "error");
    })


    getAllLinkedRegistersApiHandler(project_id).then(response => {
      setLoading(false);
      const linkRegTableData = response.data.linkedRegisters
      setCurrentYear(response.data.currentYear);
      setPreviousYear(response.data.previousYear);
      const normalizedTableData = {
        investment: normalizeTwoYear(linkRegTableData.investment),
        receivable: normalizeTwoYear(linkRegTableData.receivable),
        payable: normalizeTwoYear(linkRegTableData.payable),
        sales: normalizeTwoYear(linkRegTableData.sale),
        purchase: normalizeTwoYear(linkRegTableData.purchase),
        lease: normalizeTwoYear(linkRegTableData.lease),
        "fixed assets": normalizeTwoYear(linkRegTableData.fixedAsset),
        loans: normalizeLoan(linkRegTableData.loan),
      };

      setLinkRegisterTableData(normalizedTableData);
    }).catch(error => {
      setLoading(false);
      swal("Error", error.response.data.error || "Error: Get Linked Register API Failed!", "error");
    })


  }, [])



  const AddNewTableRow = (key) => {
    if (["view", "approver"].includes(user.responsibilities)) {
      swal("Warning", "You don't have access to add", "warning");
      return;
    }

    setLinkRegisterTableData((prev) => {
      const existingRows = prev[key] || [];

      const newRow = {
        cy: [],
        py: [],
        ...(key === "loans" && { preceding_year: [] }),
        mappedRegisterIds: {
          cy: "",
          py: "",
          ...(key === "loans" && { preceding_year: "" }),
        },
      };

      const updated = {
        ...prev,
        [key]: [...existingRows, newRow],
      };

      const newIndex = updated[key].length - 1;

      if (key === "investment") {
        setSelInvestmentRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelInvestmentRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "receivable") {
        setSelRecRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelRecRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "payable") {
        setSelPayRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelPayRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "fixedAsset") {
        setSelFixedAssetsRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelFixedAssetsRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "sales") {
        setSelSalesRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelSalesRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "purchase") {
        setSelPurchaseRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelPurchaseRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "lease") {
        setSelLeaseRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelLeaseRegPY((p) => ({ ...p, [newIndex]: [] }));
      }

      if (key === "loans") {
        setSelLoanRegCY((p) => ({ ...p, [newIndex]: [] }));
        setSelLoanRegPY((p) => ({ ...p, [newIndex]: [] }));
        setSelLoanPrecedingYear((p) => ({ ...p, [newIndex]: [] }));
      }

      return updated;
    });
  };

  const handleDrop = (e, keyName, indexId, name) => {
    console.log("Dropped:", keyName, name, draggedData);


    if (user.responsibilities === "view" || user.responsibilities === "approver") {
      swal("Warning", "You don't have access to drag and drop", "warning");
      return false;
    }
    e.preventDefault()
    if (!draggedData) return;

    setDropLoading(true);

    if (keyName === "investment") {
      if (name === "cy") {
        setSelInvestmentRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelInvestmentRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
    }

    if (keyName === "receivable") {
      if (name === "cy") {
        setSelRecRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelRecRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
    }

    if (keyName === "payable") {
      if (name === "cy") {
        setSelPayRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelPayRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
    }
    if (keyName === "loans") {

      if (name === "cy") {
        setSelLoanRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelLoanRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
      if (name === "preceding_year") {
        setSelLoanPrecedingYear((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }))
      }
    }

    if (keyName === "lease") {
      if (name === "cy") {
        setSelLeaseRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }))
      }
      if (name === "py") {
        setSelLeaseRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }))
      }
    }
    if (keyName === "fixed assets") {
      if (name === "cy") {
        setSelFixedAssetsRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }))
      }
      if (name === "py") {
        setSelFixedAssetsRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }))
      }
    }

    if (keyName === "sales") {
      if (name === "cy") {
        setSelSalesRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelSalesRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
    }

    if (keyName === "purchase") {
      if (name === "cy") {
        setSelPurchaseRegCY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }

      if (name === "py") {
        setSelPurchaseRegPY((prev) => ({
          ...prev,
          [indexId]: [
            ...(prev[indexId] || []),
            ...(Array.isArray(draggedData) ? draggedData : [draggedData]),
          ],
        }));
      }
    }
  }

  const HandleChange = (e, key, index, name = null) => {
    const data = {
      key,
      index,
      keyName: key === "loans" ? name : e.target?.name,
      value: key === "loans" ? e : e.target.value
    }
    setDropLoading(true);
    onchangeMappingLinkRegister(project_id, tb_id, data).then(response => {
      setDropLoading(false);
      setLinkRegisterTableData(response.data.data);
    }).catch(error => { setDropLoading(false); swal("Error", error.response.data.error, "error") })
  }

  const HandleMapping = (index, key) => {
    if (user.responsibilities === "view" || user.responsibilities === "approver") {
      swal("Warning", "You don't have access to map", "warning");
      return false;
    }
    setDropLoading(true);
    mappingLinkRegister(project_id, tb_id, index, key).then(response => {
      setDropLoading(false);
      swal("Success", (response.data.message || "Data Register Mapped Successfully."), "success")
    }).catch(error => {
      setDropLoading(false);
      swal("Error", error.response.data.error, "error")
    })
  }

  return (
    <>
      <div className={`${workSpaceCss.df}`} >
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>

          <div className={bookclosurecss.bookClosureContent}>
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
               <div className="d-flex align-items-center justify-content-between px-3 py-2">
              <FSTopBar />
               {/* <Button
                  btnColor={buttoncss.primary}
                  label="Previous Disclosure"
                  style={{whiteSpace: "nowrap"}}
                  //onClick={() => { }}
                /> */}
                </div>
             </div>
            <div style={{"overflow": "auto" }}>
              {
                loading ? <Loading />
                  :
                  <>
                    <div className="d-flex py-2" >
                      <div className="ml-4 mr-2"   style={{
                        width: "23%",
                        padding: "0 8px",
                        height: "8vh",        
                        display: "flex",
                        flexDirection: "column"
                      }} >
                        <div className="link-header header" style={{ display: "flex", fontFamily: "DM Sans", fontWeight: 400, fontStyle: "Regular", fontSize: "20px", lineHeight: "100%", letterSpacing: "0px", backgroundColor: "#ffffff", border: "1px solid #EAEEED", borderRadius: "17px 17px 0 0 ", borderBottom: "none"}}>
                          <p className=" text-capitalize font-sans m-0 p-3" >Import Registers</p>
                           <SearchIcon style={{ marginLeft: "auto", cursor: "pointer", paddingTop:"10px" , paddingRight: "10px"}}/>
                        </div>
                        <div className="w-100 mt-0  " style={{ borderTop: "none", border: "1px solid #eaeeed", borderRadius: "6px"}} >
                          <Card className="mt-0 link-register-page" style={{ flex: 1, display: "flex", flexDirection: "column" }}>

                            <div className="link-register-side-bar" style={{ overflowY: "auto", flex: 1 }}>
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Investment"} data={linkRegisterData?.filteredInvestmentData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Receivable"} data={linkRegisterData?.filteredReceivableData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Payable"} data={linkRegisterData?.filteredPayableData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Sales"} data={linkRegisterData?.filteredSaleData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Purchase"} data={linkRegisterData?.filteredPurchaseData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Leases"} data={linkRegisterData?.filteredLeaseData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Fixed Assets"} data={linkRegisterData?.filteredFixedAssetData} setDraggedData={setDraggedData} />
                              <LinkRegisterAccordion selectedItems={selectedItems} setSelectedItems={setSelectedItems} name={"Loans"} data={linkRegisterData?.filteredLoansData} setDraggedData={setDraggedData} />
                            </div>

                          </Card>
                        </div>
                      </div>
                      <div className="ml-2 mr-2" style={{ border: "1px solid #EAEEED", borderRadius: "20px", width: "80%" }}>
                        <div className="link-header header" style={{ fontWeight: 400, fontSize: "20px", lineHeight: "100%", letterSpacing: "0px", backgroundColor: "#f8f9f9", borderBottom: "1px solid #EAEEED", borderRadius: "20px 20px 0px 00px", display: "flex", justifyContent: "space-between" }}>
                          <p className=" text-capitalize font-sans m-0 p-3" >Map registers to your financial statements</p>
                          <div className={bookclosurecss.cypyDiv}>
                            <span className={bookclosurecss.lrCYPY}>Current Year
                              {currentYear && <DisabledDate value={currentYear} />}
                            </span>
                            <span className={bookclosurecss.lrCYPY}>Previous Year
                              {previousYear && <DisabledDate value={previousYear} />}
                            </span>
                          </div>
                        </div>
                        <div className="px-3" style={{ border: "0px solid #EAEEED", borderRadius: "0px", maxHeight: "78vh", overflow: "auto" }}>
                          {
                            Object.keys(linkRegisterTableData).length > 0 && Object.keys(linkRegisterTableData).map(ele => (
                              <LinkRegisterTable
                                HandleMapping={HandleMapping}
                                keyElement={ele}
                                data={linkRegisterTableData}
                                AddNewTableRow={AddNewTableRow}
                                handleDrop={handleDrop}
                                HandleChange={HandleChange}
                                selInvestmentRegCY={selInvestmentRegCY}
                                selInvestmentRegPY={selInvestmentRegPY}
                                selRecRegCY={selRecRegCY}
                                selRecRegPY={selRecRegPY}
                                selPayRegCY={selPayRegCY}
                                selPayRegPY={selPayRegPY}
                                selLoanRegCY={selLoanRegCY}
                                selLoanRegPY={selLoanRegPY}
                                selLoanPrecedingYear={selLoanPrecedingYear}
                                selLeaseRegCY={selLeaseRegCY}
                                selLeaseRegPY={selLeaseRegPY}
                                selFixedAssetsRegCY={selFixedAssetsRegCY}
                                selFixedAssetsRegPY={selFixedAssetsRegPY}
                                selSalesRegCY={selSalesRegCY}
                                selSalesRegPY={selSalesRegPY}
                                selPurchaseRegCY={selPurchaseRegCY}
                                selPurchaseRegPY={selPurchaseRegPY}
                              />
                            ))
                          }
                        </div>

                      </div>
                    </div>
                  </>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DisabledDate = ({ value }) => (
  <InputGroup
    class_={`${commoncss.widthFC} mb-0`}
    inputs={[
      <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
            <MobileDatePicker
              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
              disabled
              value={dayjs(value)}
              format="DD-MM-YYYY"  
               
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
        <span className="icon">
          <CalenderIcon className="vaMiddle" width={20} height={20} />
        </span>
      </>,
    ]}
  />
);


export default LinkRegister;
